import template from './umc-upload-video.component.html';
import { UniversalMediaChooseUploadVideoController as controller } from './umc-upload-video.controller';

export default {
	bindings: {
		options: '<',
		umcInstanceName: '@'
	},
	controller,
	require: {
		umcController: '^universalMediaChooser'
	},
	template
};
